import React from "react"
import mount from "core/mount"
import KitLogo from "../../../assets/images/kit-logo-black.svg"
import { PrimaryNav } from "./primary-nav"
import MobileNav from "./mobile-nav"
import { SettingsNav } from "./settings-nav"
import Container from "core/container"
import VisuallyHidden from "@kit/design/visually-hidden"
import "./tertiary/back-btn"
import "./navigation.css"
import { FocusModeSlideOutAndHide } from "core/focus-mode/focus-mode-slide-out-and-hide"
import { Link } from "core/link"
import { StatusBanner } from "./utils/status-banner"

export function Navigation({ userInfo }) {
  return (
    <FocusModeSlideOutAndHide
      mode="top"
      className="overflow-x-hidden bg-white text-black border-b border-gray-200 py-3 left-0 right-0"
    >
      <Container>
        <div className="flex justify-between items-center relative">
          <div className="flex gap-12 items-center">
            <div className="relative">
              <Link href="/dashboard" className="block" style={{ width: 54 }}>
                <KitLogo />
                <VisuallyHidden>Kit</VisuallyHidden>
              </Link>
              <StatusBanner />
            </div>
            <PrimaryNav />
          </div>
          <MobileNav userInfo={userInfo} />
          <SettingsNav userInfo={userInfo} />
        </div>
      </Container>
    </FocusModeSlideOutAndHide>
  )
}

mount({ Navigation })
